import { BookA, Settings } from "lucide-react";
import CaptureIcon from "./IconComponent/CaptureIcon";
import MenuIconTooltip from "./MenuIconTooltip";
import { MENU_CAPTURE_TOOLTIPS } from "../constants/menuTooltips";

export default function MenuCaptureNav({
  activePanel = "capture",
  onPanelChange = () => {},
  onSettingsClick = () => {},
  visible = true,
}) {
  if (!visible) return null;

  return (
    <div className="menuFilterContainer menuCaptureNavContainer">
      <MenuIconTooltip
        tooltip={MENU_CAPTURE_TOOLTIPS.capture}
        placement="left"
        portal
        className={activePanel === "capture" ? "filterIcon active" : "filterIcon"}
      >
        <CaptureIcon
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onPanelChange("capture")}
          aria-label="Capture de mot"
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_CAPTURE_TOOLTIPS.dictionary}
        placement="left"
        portal
        className={activePanel === "dictionary" ? "filterIcon active" : "filterIcon"}
      >
        <BookA
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onPanelChange("dictionary")}
          aria-label="Dictionnaire"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_CAPTURE_TOOLTIPS.settings}
        placement="left"
        portal
        className="filterIcon"
      >
        <Settings
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={onSettingsClick}
          aria-label="Paramètres de capture de mot"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>
    </div>
  );
}
